import { useAbTest } from 'ab-test/hooks/useAbTest/useAbTest'
import { AbTestKeys } from 'types/constants/AbTestKeys'

export function useFeedbackTestVariable() {
	const abTest = useAbTest({
		key: AbTestKeys.FeedbackAddToBag,
	})

	return { enabled: abTest?.enabled }
}
